import * as React from "react";
import { Routes, Route } from "react-router";
import { EmailDetails } from "../Shared/EmailDetails";
import { EmailTypeStore, MailSortBy } from "../Stores/EmailTypeStore";
import { observer } from "mobx-react";
import { PrimaryActionsConfig, DropdownActionConfig } from "Components/General/DetailListActions";
import { EmailsTable } from "./EmailsTable";
import { SearchBarWithActions } from "../Components/SearchBarWithActions";
import { withRouter, WithRouterProps } from "Components/General/WithRouter";

interface DefaultLayoutProps extends WithRouterProps {
  emailListStore: EmailTypeStore;
  actionsConfig: {
    primaryActions: PrimaryActionsConfig[];
    dropdownActions?: DropdownActionConfig[];
  };
  onSort: (sortBy: MailSortBy, sortOrder: API_MAILPAGINATION_SORTORDER) => void;
  onSelectRow: (keys: string[], emails: API_MailResponse[]) => void;
  selectedRowKeys: string[];
  onSearch: (text: string) => void;
  onLayoutChange: (text: string) => void;
  layoutMode: API_USERDATA_LAYOUTTYPE;
  isIntermediate: boolean;
  isSelectedAll: boolean;
  onSelectAll: () => void;
  onRefresh: () => void;
  isSearchBarVisible: boolean;
}

export const DefaultLayout = withRouter(
  observer(
    class extends React.Component<DefaultLayoutProps> {
      goToMailDetails = ({ id }) => {
        this.props.navigate(`${id}`);
      };

      render() {
        const {
          emailListStore,
          actionsConfig,
          onSelectRow,
          selectedRowKeys,
          isSearchBarVisible: isVisible,
        } = this.props;
        const addressKey = emailListStore.emailType === "SENT" || emailListStore.emailType === "DRAFT" ? "to" : "from";
        return (
          <Routes>
            <Route
              path={`:id`}
              element={
                <EmailDetails
                  goBack={() => {
                    this.props.navigate("..");
                  }}
                  {...actionsConfig}
                  updateEmailData={emailListStore.updateEmailData}
                  refreshList={emailListStore.refresh}
                  type={emailListStore.emailType}
                />
              }
            />
            <Route
              index
              element={
                <>
                  <SearchBarWithActions
                    isSearchBarVisible={isVisible}
                    emailType={emailListStore.emailType}
                    projectTopicInbox={emailListStore.projectInboxes}
                    onSearch={this.props.onSearch}
                    accessLevel={emailListStore.projectSpecific ? "project" : "private"}
                    actionsConfig={this.props.actionsConfig}
                    onSort={this.props.onSort}
                    sortedBy={emailListStore.sortBy}
                    sortedOrder={emailListStore.sortOrder}
                    onLayoutChange={this.props.onLayoutChange}
                    layoutMode={this.props.layoutMode}
                    onRefresh={this.props.onRefresh}
                    onSelectAll={this.props.onSelectAll}
                    isIntermediate={this.props.isIntermediate}
                    isSelectedAll={this.props.isSelectedAll}
                    switchProjectInboxes={emailListStore.switchProjectInboxes}
                  />
                  <EmailsTable
                    data={emailListStore.data}
                    total={emailListStore.total}
                    selectedRowKeys={selectedRowKeys}
                    addressKey={addressKey}
                    onRowClick={this.goToMailDetails}
                    onSelectRows={onSelectRow}
                    loadMore={emailListStore.loadMoreData}
                  />
                </>
              }
            />
          </Routes>
        );
      }
    }
  )
);
